import { fetcher } from '@/shared/fetcher'
import { logInfo } from '@/shared/logger'

export const CURRENT_CURRENCY = 'currentCurrency'
export const CURRENCY_FALLBACK = 'USD'
// this also affect currencies shown in settings,
// make sure to add missing translations too, ie. `settings.currency.option.eur`
const CURRENCY_TO_FETCH = ['USD', 'EUR', 'GBP', 'PLN']

export type CurrencySymbol = string

export type Currency = {
  [key: CurrencySymbol]: number
}

/**
 * Fetch list of currencies either from cache or API.
 *
 * @param token - Token to fetch currencies for. Default is LYX.
 * @returns - Currencies
 */
export const getCurrencies = async (
  nativeTokenSymbol = 'LYX'
): Promise<Currency> => {
  const symbol = nativeTokenSymbol.includes('ETH') ? 'ETH' : 'LYX'
  const url = `https://min-api.cryptocompare.com/data/price?fsym=${symbol}&tsyms=${CURRENCY_TO_FETCH.join(
    `,`
  )}`
  try {
    const currencies = await fetcher<Currency, Record<string, never>>(
      {
        url,
        method: 'GET',
      },
      true,
      true
    )
    return currencies || {}
  } catch {
    logInfo('Failed to fetch currencies, using fallback')
    return {} as Currency
  }
}
